import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const styles = () => ({
  root: {},
});

const Title = ({
  className,
  classes,
  text,
  value,
  align,
  color,
  test,
}) => {
  return (
    <Text
      className={classNames(classes.root, className)}
      text={value || text}
      align={align}
      variant="h2"
      weight="bold"
      color={color}
      test={test}
    />
  );
};

Title.defaultProps = {
  className: '',
  text: undefined,
  value: undefined,
  color: 'textPrimary',
  align: 'center',
  test: undefined,
};

Title.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  /**
   * @deprecated
   */
  text: PropTypes.string,
  value: PropTypes.string,
  color: PropTypes.string,
  align: PropTypes.string,
  test: PropTypes.string,
};

export default withStyles(styles)(Title);
